import { render, staticRenderFns } from "./InvoiceView.vue?vue&type=template&id=67885171&scoped=true&"
import script from "./InvoiceView.vue?vue&type=script&lang=js&"
export * from "./InvoiceView.vue?vue&type=script&lang=js&"
import style0 from "./InvoiceView.vue?vue&type=style&index=0&id=67885171&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67885171",
  null
  
)

export default component.exports